import React, { Component } from 'react';

import closeImg from '../imgs/x.svg';

class Modal extends Component {
  toggleModal = () => {
    this.props.modalactivate();
  }

  render() {
    let content;
    if (this.props.mode === 'gaugeRecent' || this.props.mode === 'radar') {
      content = (
        <div>
          <p>The Recent Rainfall page displays provisional rain gauge data in real-time for Cincinnati. Rain gauges shown on the map are colored by rainfall accumulation in inches, measured over the last six hours. The color scale on the right side of the map indicates the approximate rain accumulation value and corresponding color. The rain gauge table accumulation values are reported in inches for various accumulation periods. Manual quality assurance and quality control measures have not been applied.</p>
        </div>
      )
    }
    if (this.props.mode === 'gaugeDDF') {
      content = (
        <div>
          <h4>What is a Recurrence Interval?</h4>
          <p>A recurrence interval is a statistical measurement based on historical data denoting the likelihood of an event, in this case, an amount of rainfall in a given time period. There are two time periods available to search, 24 and 48 hours, which will return the highest recurrence interval of rainfall over the last 24 or 48 hours for a given duration of time. A toggle on the right side of a table row can show more detail concerning a particular gauge for all durations.</p>
          <h4>How to Read the Table</h4>
          <p>If '24 Hours' is chosen, then the table values show the highest return intervals per duration for the last 24 hours. When looking at a particular time duration, the recurrence interval is given in a period of time, for instance '5 yr'. This means that during the rainfall of the last 24 hours, there was a period the length of Duration equal or greater to a 5 year event. It has a probability of exceedence of once every 5 years on average.</p>
          <p className="i">Recurrence intervals and durations obtained from Bulletin 71 (Southwest Ohio)</p>
        </div>
      )
    }
    if (this.props.mode === 'disclaimer') {
      content = (
        <div>
          <p>This website contains provisional data and has not undergone a final quality control and quality assessment process.</p>
        </div>
      )
    }
    return (
      <div className={this.props.active ? 'info-modal aspect-ratio--object fixed dt' : 'dn'}>
        <div className="dtc v-mid">
          <div className="ph3 pv1 mw6 center bg-white">
            <button onClick={this.toggleModal} className="input-reset bg-white reset fr"><img src={closeImg} alt="Close the modal."/></button>
            {content}
          </div>
        </div>
      </div>
    )
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js